import "reflect-metadata";
import Vue from 'vue'
import SibSaleApp from './SibSaleApp.vue'
import GlobalService, {
    GlobalSymbols, INotificationService, NotificationSymbols, OIDCStorageStore, SibIdentity, SibAppSettings,
    ILocalizationService, LocalizationSymbols, ServiceRegistredRecord, SibSymbols, DefaultSibProvider
} from 'web-platform-core-ui';
import vuetify from './vuetify';
import router from './router';
import VueTheMask from 'vue-the-mask';
const Inputmask = require('inputmask');

import * as moment from 'moment';
import 'moment/locale/ru';
import { UserManager, WebStorageStateStore, Log } from 'oidc-client';
import loadStaticLocaliztionDictionaries from '../components/Localization';

moment.locale('ru');

Vue.use(VueTheMask);

Vue.component('VOffline', require('v-offline'));
Vue.directive('input-mask', {
    bind: function (el) {
        if (el.tagName == 'INPUT')
            new Inputmask().mask(el);
        else {
            let inp = el.getElementsByTagName('input')[0];
            new Inputmask().mask(inp);
        }
    }, 
    unbind: function (el) {
        if (el.tagName == 'INPUT')
            Inputmask.remove(el);
        else {
            let inp = el.getElementsByTagName('input')[0];
            Inputmask.remove(inp);
        }
    }
});

const settings = new SibAppSettings();
let parsingResult = settings.ParseHashParams();
if (!parsingResult)
    throw new Error("Settings parsing error");
GlobalService.SetSettings<SibAppSettings>(settings);
const store: any = new OIDCStorageStore();

const mgr = new UserManager({
    stateStore: new WebStorageStateStore({ store: store }),
    userStore: new WebStorageStateStore({ store: store }),
    authority: `${settings.IdentityServerUrl}identity`,
    client_id: '0007A50C-29F4-4206-B50F-7974742640C2',
    popup_redirect_uri: window.location.origin + '/callback_popup.html',
    response_type: 'token id_token',
    scope: 'openid profile all_claims',
    post_logout_redirect_uri: window.location.origin + '/?rand' + Math.random(),
    accessTokenExpiringNotificationTime: 60,
    automaticSilentRenew: false,
    filterProtocolClaims: false,
    loadUserInfo: true,
    monitorSession: false
})

settings.RedirectUri = window.location.origin + '/sib_callback_popup.html';

const globalService = new GlobalService();
const identityContext = new SibIdentity(mgr, store);

let redifined = [];
redifined.push(new ServiceRegistredRecord(SibSymbols.SibProvider, DefaultSibProvider, true));

globalService.LoadSibSaleConfiguration(identityContext, [], redifined);
let localizationService = globalService.Get<ILocalizationService>(LocalizationSymbols.LocalizationService);
loadStaticLocaliztionDictionaries(localizationService);
localizationService.ChangeLocalizationAsync(settings.Localization);

if (settings.IsDevVersion) {
    Vue.config.productionTip = false;
    Vue.config.devtools = true;
} else {
    Vue.config.productionTip = true;
    Vue.config.devtools = false;
}

new Vue({
    vuetify,
    router,
    render: h => h(SibSaleApp),
    provide: {
        [GlobalSymbols.GlobalService]: globalService
    }
}).$mount('#app')

function _errorEventHandler(errorMsg: string, url: string, lineNumber: string): void {
    let notificationService = globalService.Get<INotificationService>(NotificationSymbols.NotificationService);
    notificationService.Error('Ошибка', errorMsg);

    console.log(`error: ${errorMsg}, url: ${url}, lineNumber: ${lineNumber}`);
}

const _global = (window || global) as any;
_global.onerror = _errorEventHandler;